module.exports = __webpack_public_path__ + "img/banana-hat.15dd6eca.png";